import React, { useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
// import Card from "react-bootstrap/Card";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { selectApplication } from "../../store/slices/application-slice";
import { fetchApplication } from "../../store/thunks/fetch-application-thunk";
import { Container } from "react-bootstrap";
import "./ApplicationInfo.css";
import { ApplicationStatusBar } from "./ApplicationStatusBar";
import { StatusCard } from "./StatusCard";
import Background from "../Images/cardDesign.png";
import { fetchSignIn } from "../../store/thunks/fetch-sign-in-thunk";
import { selectSignIn } from "../../store/slices/signed-in-slice";

import { useLocation } from "react-router-dom";

const ApplicationDetails = ({ application, index }) => {
    // Unescape HTML entities and prevent Cross-Site Scripting XSS vulnerability.
    function htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    const indexPlusOne = index + 1
    
    const {
        App_Location,
        // ClosingDate,
        // PositionNumber,
        // PositionTitle,
        App_Date_Recd,
        App_REQID,
        App_IAID, // INDIVIDUAL ASSESSMENT SUBJECT TO CHANGE
        // References,
        PositionNumber,
        PositionTitle,
        // Location,
        ClosingDate,
        // SubmissionDate,
        App_Status,
        App_WorkHours,
        App_WorkDays,
        App_PayRate,
        App_EmploymentType,
        App_Sensitive,
        App_Department
    } = application;

    // Check if application is for an IA or not 
    const isIndividualAssessment = !App_PayRate && !ClosingDate && !App_EmploymentType   && !App_WorkDays 
const statusDetails = (status) => {
        // Application submitted
        if (status === "Application Submitted") { // Y
            return "Application successfully submitted and is on file.";
            // Application being forwarded to Division
        } else if (status === "Application Pending Referral") { // Y
            return "Application is being forwarded to the hiring department.";
            // Application forwarded to Division
        } else if (status === "Application Pending Assessment") { // Y
            return "Application is being assessed to determine if the applicant has met the minimum qualifications.";
        } else if (status === "Application Returned") { // Y
            return "Application Returned";
        } else if (status === "Not Qualified") {
            return "Applicants who have been determined not qualified may submit a written appeal to the Human Resources Director within ten working days from the date of the non-qualified notice. ";
        } else if (status === "Application Referred to Hiring Department") {
            return "Applicant has met the minimum requirements and has been referred to the hiring department.";
        } else {
            return "Pending";
        }
    };

    let statusToPercent = new Map();

    statusToPercent.set("Pending", 23);
    // DPM QA status to progress bar percentage
    statusToPercent.set("Pending Analyst Assignment", 50);
    statusToPercent.set("Application Pending Assessment", 75);
    statusToPercent.set("Application Pending Assessment", 75);
    statusToPercent.set("Application Pending Assessment", 75);
    statusToPercent.set("Application Returned", 100);
    statusToPercent.set("Not Qualified", 100);
    statusToPercent.set("Application Referred to Division", 100);

    // Division QA status to progress bar percentage
    statusToPercent.set("Pending Application Forwarding to Division", 50);
    statusToPercent.set("Application Forwarded to Division", 100);

    let statusToColor = new Map();

    // DPM QA status to progress bar color
    statusToColor.set("Pending", "");
    statusToColor.set("Pending Analyst Assignment", "");
    statusToColor.set("Application Return Pending", "");
    statusToColor.set("NQ Letter Pending", "");
    statusToColor.set("Application Referral Pending", "");
    statusToColor.set("Application Returned", "warning");
    statusToColor.set("Not Qualified", "danger");
    statusToColor.set("Application Referred to Division", "success");

    // Division QA status to progress bar color
    statusToColor.set("Application Forward Pending", "");
    statusToColor.set("Application Forwarded to Division", "success");

    // Decode values returned from FileMaker
    let decodeApp_REQID = htmlDecode(App_REQID);
    let decodeApp_RecdDate = htmlDecode(App_Date_Recd);
    // let decodeReferences = htmlDecode(References);
    let decodeClosingDate = htmlDecode(ClosingDate);
    let decodePositionNumber = htmlDecode(PositionNumber);
    let decodePositionTitle = htmlDecode(PositionTitle);

    let decodeLocation = htmlDecode(App_Location);
    let decodePayRate = htmlDecode(App_PayRate);
    let decodeWorkDays = htmlDecode(App_WorkDays);
    let decodeWorkHours = htmlDecode(App_WorkHours);
    let decodeDepartment = htmlDecode(App_Department);
    let decodedEmploymentType = htmlDecode(App_EmploymentType);
    
    return (
        <>
            <p
                className="visually-hidden">
                {
                    "Application #" + indexPlusOne + ","
                    + "Position: "+ decodePositionTitle + ","
                    + "Status:" + App_Status + ","
                    + "Application Received: " + decodeApp_RecdDate + ","
                    + "Requisition ID: " + decodeApp_REQID + ","
                    + "Position Number: " + decodePositionNumber + ","
                    + "Pay rate: " + decodePayRate + ","
                    + "Closing date: " + decodeClosingDate + ","
                    + "Department/Worksite: " + decodeDepartment + " / " + decodeLocation + ","
                    + "Work Days: " + decodeWorkDays + ","
                    + "Work Hours: " + decodeWorkHours + ","
                    + "Employment Type: " + decodedEmploymentType + ","
                    + "Sensitive: " + App_Sensitive
                }
            </p>
            <Container aria-hidden="true" className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 border-shadow">
                <Row>
                    <ApplicationStatusBar
                        isIndividualAssessment={isIndividualAssessment}
                        message={App_Status}
                        status={statusToColor.get(App_Status)}
                        percentage={statusToPercent.get(App_Status)}
                        received={decodeApp_RecdDate}
                        indexPlusOne={indexPlusOne}
                    ></ApplicationStatusBar>
                </Row>

                <Row>
                    <StatusCard
                        individualAssessmentID={App_IAID} // INDIVIDUAL ASSESSMENT SUBJECT TO CHANGE
                        isIndividualAssessment={isIndividualAssessment}
                        positionTitle={decodePositionTitle}
                        reqId={decodeApp_REQID}
                        positionNumber={decodePositionNumber}
                        payRate={decodePayRate}
                        closingDate={decodeClosingDate}
                        department={decodeDepartment + " / " + decodeLocation}
                        workDays={decodeWorkDays}
                        employmentType={decodedEmploymentType}
                        workHours={decodeWorkHours}
                        sensitive={App_Sensitive === "Yes" ? true : false}
                        nonSensitive={App_Sensitive === "No" ? true : false}
                    ></StatusCard>
                </Row>
                <Row>
                    <Container className="border-shadow mb-3 rounded-4">
                        <Row
                            className="rounded-4"
                            style={{
                                backgroundImage: `url(${Background})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover"
                            }}
                        >
                            <Col>
                                <h4 className="pb-2 border-bottom border-5 border-warning job-font">
                                    Status Details:
                                </h4>
                            </Col>
                            <Row className="mb-5">
                                <b>{statusDetails(App_Status)}</b>
                            </Row>
                        </Row>
                    </Container>
                </Row>
            </Container>
            <Container className="bg-dark-subtle bg-opacity-25 my-4 rounded-5 ">
                <Row className="justify-content-center border-bottom border-4" />
            </Container>
        </>
    );
    // , , App_PayRate, App_EmploymentType, App_Sensitive;
};

export const ApplicationInfo = () => {
    const application = useSelector(selectApplication);
    const applicationStatus = useSelector((state) => state.application.status);
    // const applicationError = useSelector((state) => state.application.error);
    const isSignedIn = useSelector(selectSignIn);
    const dispatch = useDispatch();

    // If user is signed in,
    // redirect to the home page

    useEffect(() => {
        if (applicationStatus === "idle") {
            dispatch(fetchApplication());
            dispatch(fetchSignIn());
        }
    }, [dispatch, applicationStatus, application]);

    // Choose what to scroll to when loading in to the page
    const ref = useRef(null);

    // Extracts pathname property(key) from an object
    const { pathname } = useLocation();

    // Automatically scrolls to top whenever pathname changes
    useEffect(() => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
    }, [pathname]);

    let content;

    if (applicationStatus === "loading") {
        content = (
            <Spinner 
                animation="border" 
                role="status"
                aria-label="Loading Applications">
                    <span className="visually-hidden">Loading Applications...</span>
            </Spinner>
        );
    } else if (applicationStatus === "succeeded") {
        content = <p 
                    autoFocus
                    role="status"
                    aria-label="Submitted applications"
                    >
                        Submitted applications:</p>;
    } else if (!isSignedIn) {
        content = (
            <Col>
                Please{" "}
                <Link
                    style={{
                        textDecoration: "none"
                    }}
                    to={"/signin"}
                >
                    sign in
                </Link>{" "}
                to view submitted applications.
            </Col>
        );
    } else if (applicationStatus === "failed" && application.length === 0) {
        content = <p autoFocus>No Applications Submitted</p>;
    }

    return (
        <>
                <Row
                    style={{
                        backgroundColor: "dimgray",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover"
                    }}
                    ref={ref}
                >
                    <Col xss={12} xs={12} xl={7} className="mx-auto">
                        <Row className="bg-body-secondary rounded-3 mx-auto shadow-lg border border-black border-1 border-opacity-10 mt-2">
                            <Row className="bg-body-secondary rounded-top-3 mx-auto">
                                <Row className="mx-auto justify-content-start bg-body-secondary">
                                    <Col className="col-auto pt-3 ">
                                        <h3 className="text-center opacity-75 mt-3 mb-4 border-bottom border-warning border-5 title-font h-50">
                                            {content}
                                        </h3>
                                    </Col>
                                </Row>
                            </Row>

                            <Row className="justify-content-center mx-auto">
                                <Row className="mb-3 pb-2">
                                    {application.length > 0 &&
                                        application.map((app, index) => {
                                            return (
                                                <ApplicationDetails
                                                    application={app}
                                                    key={index}
                                                    index={index}
                                                />
                                            );
                                        })}
                                </Row>
                            </Row>
                        </Row>
                    </Col>
                </Row>
        </>
    );
};
